module.exports = __webpack_public_path__ + "media/images/icon-logo-google@3x-a928ebcb09639ca750e1fde8d6e4cb57.png";